import React, { useState } from "react";
import CreateAssetSingle from "../AssetManagement/CreateAssetSingle";
import CreateAssetBulk from "../AssetManagement/CreateAssetBulk";
import CreateAssetType from "../AssetManagement/AssetTypeRequests";
import ApproveAssetTypeRequests from "../AssetManagement/ApproveAssetTypeRequests";
import PageTitle from "../../components/PageTitle";
import { toggleMenu } from "../../utils/helpers";

const NewAssetEnrollment = ({ title }) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { label: "Create Asset", component: CreateAssetSingle },
    { label: "Bulk Create Asset", component: CreateAssetBulk },
    { label: "Asset Type Request", component: CreateAssetType },
    {
      label: "Approve Asset Type Request",
      component: ApproveAssetTypeRequests,
    },
  ];

  const ActiveComponent = tabs[activeTab].component;

  return (
    <div className="wrapper-body">
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} />
      </div>
      <div className="card p-3">
        <ul className="nav nav-tabs">
          {tabs.map((t, i) => (
            <li className="nav-item" key={i}>
              <button
                className={`nav-link ${activeTab === i ? "active" : ""}`}
                onClick={() => setActiveTab(i)}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>

        <div>
          <ActiveComponent />
        </div>
      </div>
    </div>
  );
};

export default NewAssetEnrollment;
